/**
 * App Header schema terms
 *
 * @package ext-components-base
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export const appHeader = {
	height: {
		label: "schema:appHeader.height#label",
		description: "schema:appHeader.height#description"
	},
	heightValues: {
		small: {
			label: "schema:appHeader.height#values.small#label",
			description: "schema:appHeader.height#values.small#label"
		},
		medium: {
			label: "schema:appHeader.height#values.medium#label",
			description: "schema:appHeader.height#values.medium#label"
		},
		large: {
			label: "schema:appHeader.height#values.large#label",
			description: "schema:appHeader.height#values.large#label"
		}
	},
	heightConstraints: {
		patternErrorMessage: "schema:appHeader.height#constraints.patternError#message"
	}
};
